export const seededUUIDNamespace = "2cf6bbbd-3c94-4897-8d14-7692b828efd7";
